export default __webpack_public_path__ + "static/media/p3-1.fd4c770d.png";